import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { Instagram, Youtube } from 'lucide-react';
import { LogoWhite } from './Logo';

import { API_URL } from '../utils/apiUrl';

const Footer = () => {
  const [socialLinks, setSocialLinks] = useState({});

  useEffect(() => {
    axios.get(`${API_URL}/api/settings`).then(({ data }) => setSocialLinks(data)).catch(() => {});
  }, []);

  const hasSocial = socialLinks.instagram_url || socialLinks.tiktok_url || socialLinks.x_url || socialLinks.youtube_url;

  return (
    <footer className="bg-[#111] text-white pt-14 pb-8 px-6 lg:px-12" data-testid="global-footer">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <div className="mb-4"><LogoWhite height={44} /></div>
            <p className="text-[13px] text-neutral-400 leading-relaxed">
              Bağımsız ürün test platformu.<br />
              Markalarla ticari ortaklık kurulmaz.<br />
              Tüm değerlendirmeler tarafsız ve şeffaftır.
            </p>
          </div>
          <div>
            <h5 className="text-xs font-semibold uppercase tracking-widest mb-5 text-neutral-500">Menü</h5>
            <div className="flex flex-col gap-3">
              <Link to="/products" className="text-sm text-neutral-400 hover:text-white transition" data-testid="footer-products">Test Edilmiş Ürünler</Link>
              <Link to="/about" className="text-sm text-neutral-400 hover:text-white transition" data-testid="footer-about">Hakkımızda</Link>
              <Link to="/submit" className="text-sm text-neutral-400 hover:text-white transition" data-testid="footer-submit">Satıcılar İçin Ürün Test Başvurusu</Link>
            </div>
          </div>
          <div>
            <h5 className="text-xs font-semibold uppercase tracking-widest mb-5 text-neutral-500">Kurumsal</h5>
            <div className="flex flex-col gap-3">
              <Link to="/test-procedures" className="text-sm text-neutral-400 hover:text-white transition" data-testid="footer-procedures">Test Prosedürlerimiz</Link>
              <Link to="/terms" className="text-sm text-neutral-400 hover:text-white transition" data-testid="footer-terms">Kurum Tüzüğü</Link>
              <Link to="/privacy" className="text-sm text-neutral-400 hover:text-white transition" data-testid="footer-privacy">Gizlilik Politikası</Link>
            </div>
          </div>
          <div>
            <h5 className="text-xs font-semibold uppercase tracking-widest mb-5 text-neutral-500">İletişim</h5>
            <div className="flex flex-col gap-3">
              <Link to="/contact" className="text-sm text-neutral-400 hover:text-white transition" data-testid="footer-contact">İletişim Formu</Link>
              <span className="text-sm text-neutral-400">İstanbul, Türkiye</span>
            </div>
          </div>
        </div>

        <div className="border-t border-white/10 pt-6 flex flex-col md:flex-row justify-between items-center gap-3">
          <p className="text-xs text-neutral-500" translate="no">&copy; 2026 TestettiK&reg; Tüm hakları saklıdır.</p>
          <p className="text-[10px] text-neutral-600 italic">Hiçbir firma ile ticari ortaklık kurulmaz. Tüm değerlendirmeler bağımsızdır.</p>
        </div>

        {hasSocial && (
          <div className="flex items-center justify-center gap-5 pt-6" data-testid="footer-social-icons">
            {socialLinks.instagram_url && (
              <a href={socialLinks.instagram_url} target="_blank" rel="noopener noreferrer"
                aria-label="Instagram hesabımız" title="Instagram"
                data-testid="footer-instagram-link" className="text-neutral-500 hover:text-white transition p-1">
                <Instagram className="w-5 h-5" />
              </a>
            )}
            {socialLinks.tiktok_url && (
              <a href={socialLinks.tiktok_url} target="_blank" rel="noopener noreferrer"
                aria-label="TikTok hesabımız" title="TikTok"
                data-testid="footer-tiktok-link" className="text-neutral-500 hover:text-white transition p-1">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-2.88 2.5 2.89 2.89 0 0 1 0-5.78c.27 0 .54.04.79.1v-3.5a6.37 6.37 0 0 0-.79-.05A6.34 6.34 0 0 0 3.15 15.3a6.34 6.34 0 0 0 6.34 6.34 6.34 6.34 0 0 0 6.34-6.34V8.67a8.21 8.21 0 0 0 4.76 1.52v-3.5a4.82 4.82 0 0 1-1-.01z"/></svg>
              </a>
            )}
            {socialLinks.x_url && (
              <a href={socialLinks.x_url} target="_blank" rel="noopener noreferrer"
                aria-label="X hesabımız" title="X (Twitter)"
                data-testid="footer-x-link" className="text-neutral-500 hover:text-white transition p-1">
                <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24"><path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/></svg>
              </a>
            )}
            {socialLinks.youtube_url && (
              <a href={socialLinks.youtube_url} target="_blank" rel="noopener noreferrer"
                aria-label="YouTube kanalımız" title="YouTube"
                data-testid="footer-youtube-link" className="text-neutral-500 hover:text-white transition p-1">
                <Youtube className="w-5 h-5" />
              </a>
            )}
          </div>
        )}
      </div>
    </footer>
  );
};

export default Footer;
